<template>
  <span class="availability-indicator">
    <span
      v-if="isStocked"
      class="availability-indicator__available"
    >
      <span
        class="availability-indicator__trafficlight availability-indicator__trafficlight__available"
      />
      {{ $dict.get('dealer-Locator.Availability-Indicator.Available') }}
    </span>
    <span
      v-else
      class="availability-indicator__likelyavailable"
    >
      <span
        class="availability-indicator__trafficlight availability-indicator__trafficlight__likelyavailable"
      />
      {{ $dict.get('dealer-Locator.Availability-Indicator.Likely-Available') }}
    </span>
  </span>
</template>

<script setup lang="ts">
interface Props {
  isStocked?: boolean | null;
}

withDefaults(defineProps<Props>(), {
  isStocked: false,
});
</script>

<style scoped src="./availability-indicator" />
